import { render } from "./BlockHashes.vue?vue&type=template&id=363434b8"
import script from "./BlockHashes.vue?vue&type=script&lang=js"
export * from "./BlockHashes.vue?vue&type=script&lang=js"
script.render = render

export default script